import * as Dropdown from '@radix-ui/react-dropdown-menu';
import cx from 'classnames';

import { Slot } from '@radix-ui/react-slot';

import Icon from '../Icon/Icon';

import styles from './PillDropdown.module.css';

import { ReactComponent as ChevronDownSvg } from '@frontend/icons/chevron-down.svg';

interface PillDropdownProps extends Dropdown.DropdownMenuProps {
  children: React.ReactNode;
}

export function PillDropdownButtonArrow() {
  return (
    <Icon
      className={cx(styles['button-arrow'])}
      component={<ChevronDownSvg />}
      fillWithCurrentColor={false}
      size={16}
    />
  );
}

export function PillDropdownTrigger({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <Dropdown.Trigger className={styles['trigger']} asChild>
      {children}
    </Dropdown.Trigger>
  );
}

export function PillDropdownContent({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <Dropdown.Portal>
      <Dropdown.Content
        align="start"
        sideOffset={4}
        className={styles['content']}
      >
        {children}
      </Dropdown.Content>
    </Dropdown.Portal>
  );
}

export function PillDropdownItem({
  children,
  asChild,
  ...otherProps
}: {
  children: React.ReactNode;
  asChild?: boolean;
}) {
  const Comp = asChild ? Slot : 'span';

  return (
    <Dropdown.Item className={styles['item']} asChild>
      <Comp {...otherProps}>{children}</Comp>
    </Dropdown.Item>
  );
}

export default function PillDropdown({
  children,
}: PillDropdownProps): JSX.Element {
  return <Dropdown.Root modal={false}>{children}</Dropdown.Root>;
}
